import { apiClient } from '@/lib/api-client';
import type { FeatureAccessLevel } from '@/features/featureFlags';

/**
 * Server-side feature-flag definition. Mirrors
 * ``backend/features/serializers.py::FeatureFlagSerializer``.
 *
 * The frontend uses this to drive ``useFeatureAccess`` decisions; this is
 * the API equivalent of the old hardcoded ``FEATURE_FLAGS`` map.
 */
export interface FeatureFlagFromServer {
  flag_key: string;
  access_level: FeatureAccessLevel;
  is_enabled: boolean;
  name: string;
  status: 'PLANNED' | 'IN_PROGRESS' | 'LIVE' | 'PAUSED' | 'RETIRED';
}

export async function fetchFeatureFlags(): Promise<FeatureFlagFromServer[]> {
  const response = await apiClient.get<FeatureFlagFromServer[]>('/features/flags/');
  return response.data;
}
